import { DOTS, usePagination } from "./usePagination";

import React from "react";
import classnames from "classnames";

const Pagination = ({
  onPageChange,
  totalCount,
  siblingCount = 1,
  currentPage,
  pageSize,
}) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  }) || [];

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    if (currentPage < paginationRange.length) {
      onPageChange(currentPage + 1);
    }
  };

  const onPrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  let lastPage = paginationRange[paginationRange.length - 1];

  return (
    <ul className="pagination">
      <li>
        <a
          href="#"
          className={classnames("", {
            disabled: currentPage === 1,
          })}
          onClick={onPrevious}
        >
          <i className="icon icon-arrow-left" />
        </a>
      </li>
      {paginationRange.map((pageNumber, index) => {
        if (pageNumber === DOTS) {
          return (
            <li className="pagination-item dots" key={index}>
              &#8230;
            </li>
          );
        }

        return (
          <li
            key={index}
            className={classnames("", {
              current: pageNumber === currentPage,
            })}
            onClick={() => onPageChange(pageNumber)}
          >
            <a href="#">{pageNumber}</a>
          </li>
        );
      })}
      <li>
        <a
          href="#"
          className={classnames("pagination-item", {
            disabled: currentPage === lastPage,
          })}
          onClick={onNext}
        >
          <i className="icon icon-arrow-right" />
        </a>
      </li>
    </ul>
  );
};

export default Pagination;
